export function isSuperset<T>(set: ReadonlySet<T>, subset: Iterable<T>): boolean {
	for (const elem of subset) {
		if (!set.has(elem)) {
			return false;
		}
	}
	return true;
}

export function areEqual<T>(setA: ReadonlySet<T>, setB: ReadonlySet<T>): boolean {
	if (setA.size !== setB.size) {
		return false;
	}

	for (const elem of setB) {
		if (!setA.has(elem)) {
			return false;
		}
	}

	return true;
}

export function union<T>(setA: ReadonlySet<T>, ...otherSets: Iterable<T>[]): Set<T> {
	const setC: Set<T> = new Set(setA);
	for (const setB of otherSets) {
		for (const elem of setB) {
			setC.add(elem);
		}
	}
	return setC;
}

export function union2<T>(iterables: Iterable<T>[]): Set<T> {
	const set: Set<T> = new Set();
	for (const iterable of iterables) {
		for (const item of iterable) {
			set.add(item);
		}
	}
	return set;
}

export function intersection<T>(setA: ReadonlySet<T>, setB: Iterable<T> | undefined): Set<T> {
	// An optimization
	if (setB instanceof Set && setA.size < setB.size) {
		return intersection(setB, setA);
	}

	const setC: Set<T> = new Set();

	if (setB) {
		for (const elem of setB) {
			if (setA.has(elem)) {
				setC.add(elem);
			}
		}
	}

	return setC;
}

export function countIntersection<T>(setA: ReadonlySet<T>, setB: Iterable<T> | undefined): number {
	let c = 0;

	if (setB) {
		for (const elem of setB) {
			if (setA.has(elem)) {
				++c;
			}
		}
	}

	return c;
}

export function doesIntersect<T>(setA: ReadonlySet<T>, setB: Iterable<T>): boolean {
	for (const elem of setB) {
		if (setA.has(elem)) {
			return true;
		}
	}
	return false;
}

export function difference<T>(setA: ReadonlySet<T>, setB: Iterable<T>): Set<T> {
	const setC: Set<T> = new Set(setA);
	for (const elem of setB) {
		setC.delete(elem);
	}
	return setC;
}

export function doUnion<T>(a: Set<T>, b: Iterable<T>): void {
	for (const item of b) {
		a.add(item);
	}
}

export function doDifference<T>(a: Set<T>, b: Iterable<T>): void {
	if (b instanceof Set && a.size < b.size) {
		// This is an optimized version for sets that iterates the smaller set
		for (const item of a) {
			if (b.has(item)) {
				a.delete(item);
			}
		}
	} else {
		for (const item of b) {
			a.delete(item);
		}
	}
}
